import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { fonts } from './fonts.js';
import { colors } from './colors.js';
import { Themes } from '../theme.types.js';
import { breakpoints } from './breakpoints.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var defaultFonts = {
  family: fonts.SBonus.fontFamily,
  sizeSmall: fonts.SBonus.sizes.xxs,
  sizeMiddle: fonts.SBonus.sizes.xxs,
  sizeLarge: fonts.SBonus.sizes.xs
};
var fontSettings = {
  fontVariant: 'tabular-num',
  fontFeatureSettings: 'tnum'
};
var defaultCornerRadius = '2px';
var transparentBorder = 'transparent';
var components = {
  name: Themes.NEUTRAL,
  accordion: {
    fontFamily: fonts.SBonus.fontFamily,
    fontSize: fonts.SBonus.sizes.xs.fontSize,
    fontWeightTitle: fonts.SBonus.weights.medium,
    fontWeightContent: fonts.SBonus.weights.regular,
    lineHeight: fonts.SBonus.sizes.xs.lineHeight,
    "default": {
      color: colors.grey800,
      disabledColor: colors.grey400,
      itemBgColor: colors.white,
      focusColor: colors.primary200,
      hoverColor: colors.grey100
    },
    filled: {
      itemBgColor: colors.grey100
    },
    darkMode: {
      color: colors.white,
      disabledColor: colors.grey500,
      bgColor: colors.grey800,
      disabledBg: colors.grey800,
      itemBgColor: colors.grey900,
      focusColor: colors.grey400,
      hoverColor: colors.grey700
    }
  },
  alert: {
    fontFamily: fonts.SBonus.fontFamily,
    fontSize: fonts.SBonus.sizes.xs.fontSize,
    lineHeight: fonts.SBonus.sizes.xs.lineHeight,
    errorBackgroundColor: colors.error50,
    errorTextColor: colors.error900,
    warningBackgroundColor: colors.warning50,
    warningTextColor: colors.warning900,
    infoBackgroundColor: colors.info50,
    infoTextColor: colors.info900,
    successBackgroundColor: colors.success50,
    successTextColor: colors.success900
  },
  button: {
    fonts: defaultFonts,
    letterSpacing: fonts.SBonus.defaultLetterSpacing,
    focusColor: colors.primary200,
    borderRadius: defaultCornerRadius,
    fontWeight: fonts.SBonus.weights.medium,
    fontWeightRegular: fonts.SBonus.weights.regular,
    primary: {
      background: colors.primary,
      focusBackground: colors.primary,
      activeBackground: colors.primary,
      color: colors.white,
      hoverBackground: colors.primary800,
      borderColor: transparentBorder,
      disabledBackground: colors.primary100,
      disabledColor: colors.white
    },
    secondary: {
      background: colors.grey100,
      hoverBackground: colors.grey400,
      disabledBackground: colors.grey100,
      borderColor: transparentBorder,
      color: colors.grey900,
      disabledColor: colors.grey400
    },
    "default": {
      color: colors.primary,
      hoverColor: colors.primary800,
      disabledColor: colors.primary100,
      borderColor: colors.primary
    },
    link: {
      color: colors.primary,
      hoverColor: colors.primary800,
      disabledColor: colors.primary100,
      linkTextDecoration: 'none'
    },
    text: {
      color: colors.grey800,
      hoverColor: colors.primary800,
      disabledColor: colors.grey400
    }
  },
  checkbox: {
    fonts: _objectSpread(_objectSpread({}, defaultFonts), {}, {
      sizeSmall: fonts.SBonus.sizes.xxs,
      sizeLarge: fonts.SBonus.sizes.s
    }),
    borderColor: colors.grey,
    checkedBorderColor: colors.secondary,
    disabledBorderColor: colors.secondary,
    checkedBackgroundColor: colors.secondary,
    hoverCheckedBorderColor: colors.secondary800,
    hoverCheckedBackgroundColor: colors.secondary800,
    hoverBorderColor: colors.secondary,
    tickColor: colors.white,
    smallSize: fonts.SBonus.sizes.xxxs.lineHeight,
    largeSize: fonts.SBonus.sizes.xs.lineHeight
  },
  datePicker: _objectSpread(_objectSpread({}, fontSettings), {}, {
    fontFamily: fonts.SBonus.fontFamily,
    fontSizeSmall: fonts.SBonus.sizes.xxs,
    fontSizeMiddle: fonts.SBonus.sizes.xxs,
    fontSizeLarge: fonts.SBonus.sizes.xs,
    color: colors.grey,
    hoverColor: colors.grey900,
    borderColor: colors.grey300,
    borderFocusColor: colors.primary,
    highlightColor: colors.primary,
    highlightFocusColor: colors.primary800,
    fontSizeDropdown: fonts.SBonus.sizes.xs
  }),
  drawer: {
    fontFamily: fonts.SBonus.fontFamily,
    focusColor: colors.primary200,
    defaultFontSize: fonts.SBonus.sizes.s
  },
  form: {
    labelFontSize: fonts.SBonus.sizes.xs.fontSize,
    helpTextFontSize: fonts.SBonus.sizes.xxs.fontSize,
    labelColor: colors.grey,
    helpInfoColor: colors.grey500,
    helpWarningColor: colors.warning800,
    helpErrorColor: colors.error800
  },
  grid: {
    mobile: breakpoints.mobile,
    tablet: breakpoints.tablet
  },
  input: _objectSpread(_objectSpread({}, fontSettings), {}, {
    fontFamily: fonts.SBonus.fontFamily,
    fontWeight: fonts.SBonus.defaultWeight,
    fontSizeSmall: fonts.SBonus.sizes.xxs.fontSize,
    fontSizeMiddle: fonts.SBonus.sizes.xs.fontSize,
    fontSizeLarge: fonts.SBonus.sizes.xs.fontSize,
    letterSpacing: fonts.SBonus.defaultLetterSpacing,
    lineHeight: fonts.SBonus.sizes.s.lineHeight,
    highlightColor: colors.grey300,
    textColor: colors.grey800,
    highlightHoverColor: colors.primary500,
    highlightFocusColor: colors.primary200,
    disabledBackgroundColor: colors.grey200,
    buttonTextColor: colors.white,
    buttonBackgroundColor: colors.secondary,
    buttonHoverBackgroundColor: colors.secondary800,
    buttonDisabledBackgroundColor: colors.grey400,
    warningColor: colors.warning800,
    warningShadow: colors.warning200,
    errorColor: colors.error800,
    errorShadow: colors.error200,
    selectedItemBgColor: colors.primary50,
    inputBackgroundColor: 'unset',
    borderColor: "1px solid ".concat(colors.grey300),
    borderBottom: "1px solid ".concat(colors.grey300),
    placeholderTextColor: colors.grey400,
    placeholderTextStyle: 'normal',
    borderRadius: defaultCornerRadius
  }),
  modal: {
    fontFamily: fonts.SBonus.fontFamily,
    overlayColor: colors.grey500,
    titleColor: colors.grey,
    titleFontSize: fonts.SBonus.sizes.m,
    titleFontWeight: fonts.SBonus.weights.regular
  },
  popover: {
    fontFamily: fonts.SBonus.fontFamily,
    defaultFontSize: fonts.SBonus.sizes.xxs
  },
  radio: {
    fontFamily: fonts.SBonus.fontFamily,
    fontSize: fonts.SBonus.sizes.xs.fontSize,
    color: colors.grey800,
    borderColor: colors.grey800,
    checkedBorderColor: colors.primary500,
    checkedDotColor: colors.primary500,
    focusColor: colors.primary200,
    hoverColor: colors.primary800,
    shadowColor: colors.secondary100,
    disabledColor: colors.grey400
  },
  select: _objectSpread(_objectSpread({}, fontSettings), {}, {
    fontFamily: fonts.SBonus.fontFamily,
    fontWeight: fonts.SBonus.weights.regular,
    fontWeightSelected: fonts.SBonus.weights.medium,
    fontSizeExtraSmall: fonts.SBonus.sizes.xxxs,
    fontSizeSmall: fonts.SBonus.sizes.xxs,
    fontSizeMiddle: fonts.SBonus.sizes.xs,
    fontSizeLarge: fonts.SBonus.sizes.xs,
    color: colors.grey,
    borderFocusColor: colors.primary200,
    hoverItemBgColor: colors.grey100,
    selectedItemBgColor: colors.primary50,
    selectDropdownFont: fonts.SBonus.sizes.xs,
    borderColor: "1px solid ".concat(colors.grey300),
    borderBottom: "1px solid ".concat(colors.grey300),
    placeholderTextColor: colors.grey400,
    placeholderTextStyle: 'unset',
    borderRadius: defaultCornerRadius,
    arrowColor: colors.grey400,
    selectedItemGroupLabelColor: colors.grey600
  }),
  "switch": {
    fontFamily: fonts.SBonus.fontFamily,
    fontSizeMiddle: fonts.SBonus.sizes.xs,
    fontSizeSmall: fonts.SBonus.sizes.xs,
    color: colors.grey,
    fontWeight: fonts.SBonus.weights.regular,
    offBackgroundColor: colors.grey400,
    offBackgroundColorHover: colors.grey500,
    offBackgroundColorDisabled: colors.grey200,
    onBackgroundColor: colors.primary,
    onBackgroundColorHover: colors.primary800,
    onBackgroundColorDisabled: colors.primary100,
    focusColor: colors.primary
  },
  tab: {
    fontFamily: fonts.SBonus.fontFamily,
    fontSize: fonts.SBonus.sizes.xs.fontSize,
    boldFontWeight: fonts.SBonus.weights.medium,
    regularFontWeight: fonts.SBonus.weights.regular,
    color: colors.grey,
    focusColor: colors.secondary500,
    shadowColor: colors.secondary100,
    hoverColor: colors.secondary800,
    disabledColor: colors.secondary100,
    defaultTabColor: colors.grey800,
    defaultDisabledTabColor: colors.grey400
  },
  tag: {
    fonts: defaultFonts,
    lineHeight: fonts.SBonus.sizes.s.lineHeight,
    color: colors.white,
    textColor: colors.grey,
    focusColor: colors.primary300,
    backgroundColor: colors.secondary,
    hoverColor: colors.secondary800,
    disabledColor: colors.secondary100,
    defaultTagColor: colors.grey,
    defaultDisabledTagColor: colors.grey500,
    defaultTagBackgroundColor: colors.white,
    borderColor: transparentBorder,
    light: {
      textColor: colors.primary900,
      backgroundColor: colors.primary50,
      disabledColor: colors.primary200,
      disabledBackgroundColor: colors.primary50,
      hoverBackgroundColor: colors.primary100,
      borderColor: transparentBorder
    }
  }
};

export { components };
//# sourceMappingURL=components.js.map
